function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function renderNode(tagName, content) {
  var element = content.xmlns ? document.createElementNS(content.xmlns, tagName) : document.createElement(tagName);

  for (var _i2 = 0, _Object$entries = Object.entries(content); _i2 < _Object$entries.length; _i2++) {
    var _ref3 = _Object$entries[_i2];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];

    if (key === 'children') {
      for (var _i3 = 0, _Object$entries2 = Object.entries(content); _i3 < _Object$entries2.length; _i3++) {
        var _ref6 = _Object$entries2[_i3];

        var _ref5 = _slicedToArray(_ref6, 2);

        var _key = _ref5[0];
        var _value = _ref5[1];

        if (typeof _value === 'string') {
          element.appendChild(document.createTextNode(_value));
        } else {
          element.appendChild(renderNode(_key, _value));
        }
      }
    } else if (key === 'style') {
      Object.assign(element.style, value);
    } else if (key === 'textContent') {
      element.textContent = value;
    } else {
      element.setAttribute(key, value.toString());
    }
  }

  return element;
}

export function createElement(tagName, content, container) {
  var el = renderNode(tagName, content || {});
  container === null || container === void 0 ? void 0 : container.appendChild(el);
  return el;
}
export default createElement;